import React from "react"
import GradiLink from "./gradi-link"
import { Link } from "gatsby"

const LocationLinks = ({ links }) => {
  if (links === null || links === undefined) {
    return <div></div>
  }
  return (
    <div className="flex flex-col gap-10 uppercase">
      {links.menu ? (
        <GradiLink underline to={links.menu}>
          view our menu
        </GradiLink>
      ) : null}
      {links.booking ? (
        <GradiLink underline to={links.booking}>
          Make a booking
        </GradiLink>
      ) : null}
      {links.orderDelivery ? (
        <GradiLink underline to={links.orderDelivery}>
          order delivery
        </GradiLink>
      ) : null}
      {links.orderPickup ? (
        <GradiLink underline to={links.orderPickup}>
          order pickup
        </GradiLink>
      ) : null}
    </div>
  )
}

export default LocationLinks
